export default function BrandSection() {
  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="w-full px-4 md:px-6 lg:px-10">
        <div className="max-w-3xl mx-auto text-center">
          <div className="mb-10">
            <img
              src="https://readdy.ai/api/search-image?query=Elegant%20minimalist%20line%20art%20illustration%20of%20an%20open%20book%20with%20a%20magnifying%20glass%20hovering%20above%20it%20on%20a%20warm%20cream%20paper%20texture%20background%2C%20delicate%20thin%20ink%20lines%20with%20subtle%20golden%20accents%2C%20scandinavian%20minimalist%20design%20style%2C%20soft%20warm%20beige%20and%20muted%20brass%20color%20palette%2C%20simple%20refined%20illustration%2C%20clean%20handcrafted%20aesthetic%2C%20intellectual%20discovery%20theme&width=200&height=200&seq=brand-illustration-v2-10&orientation=squarish"
              alt="Open book with magnifying glass minimalist illustration"
              title="Kakobuy Finds - Smart Product Discovery"
              className="w-20 h-20 object-contain mx-auto"
              loading="lazy"
            />
          </div>

          <p className="text-sm font-label tracking-widest uppercase text-foreground-500 mb-6">
            Why We Built This
          </p>

          <div className="space-y-4">
            <p className="font-heading text-xl md:text-2xl text-foreground-800 leading-relaxed">
              Kakobuy Finds was born from a simple idea:{" "}
              <strong className="text-foreground-950 font-semibold">
                shopping should feel exciting, not exhausting.
              </strong>
            </p>
            <p className="text-base md:text-lg text-foreground-600 leading-relaxed">
              We noticed that discovering great products online had become overwhelming. Too many tabs, scattered links, and no way to compare. The{" "}
              <strong className="text-foreground-900">
                Kakobuy Spreadsheet
              </strong>{" "}
              changed everything — it organized thousands of products into clean, searchable lists that anyone could use.
            </p>
            <p className="text-base md:text-lg text-foreground-600 leading-relaxed">
              This site is our way of sharing the best spreadsheet-based shopping resources with the world. Every category, every guide, and every recommendation is crafted to help you{" "}
              <strong className="text-foreground-900">
                find better products, faster.
              </strong>
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}